type AuthCallbackLocation = Pick<Location, 'search' | 'hash'>

let capturedCallbackLocation: AuthCallbackLocation | null = null

function isAuthCallbackPath(pathname: string): boolean {
  return pathname === '/auth/callback' || pathname.endsWith('/auth/callback')
}

/** Persist OAuth callback query/hash before Supabase detectSessionInUrl can strip them. */
export function captureAuthCallbackParamsIfNeeded(): AuthCallbackLocation | null {
  if (typeof window === 'undefined') {
    return null
  }
  if (!isAuthCallbackPath(window.location.pathname)) {
    return null
  }
  if (!capturedCallbackLocation) {
    capturedCallbackLocation = {
      search: window.location.search,
      hash: window.location.hash,
    }
  }
  return capturedCallbackLocation
}

export function getAuthCallbackLocation(
  location: Pick<Location, 'search' | 'hash'> = window.location
): AuthCallbackLocation {
  captureAuthCallbackParamsIfNeeded()
  if (capturedCallbackLocation) {
    return capturedCallbackLocation
  }
  return {
    search: location.search,
    hash: location.hash,
  }
}

/** Test-only reset */
export function resetAuthCallbackCaptureForTests(): void {
  capturedCallbackLocation = null
}
